
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Vitals = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M18.3,2.9h-1a6.5,6.5,0,0,0-4.8,2.3A6.5,6.5,0,0,0,7.7,2.8h-1c-3.3.7-5.6,3.9-4.5,8.5.5,1.6,2.2,6.4,10.3,10.8h0c8.1-4.4,9.8-9.2,10.3-10.8C23.9,6.8,21.6,3.6,18.3,2.9ZM4.2,6.3A4.5,4.5,0,0,1,7,4.3h.7a5.2,5.2,0,0,1,3.7,1.8l1.1,1.2,1.1-1.2a5.2,5.2,0,0,1,3.7-1.8H18a4.5,4.5,0,0,1,2.8,2,5.7,5.7,0,0,1,.5,4.7c-.1.2-.1.5-.2.8h-6l-1.5,2.7L10.3,7.8l-2.1,4H3.9c-.1-.3-.1-.6-.2-.8A5.7,5.7,0,0,1,4.2,6.3Zm8.3,14.2C8,17.9,5.7,15.2,4.6,13.2H9.1l1.1-2.1,3.4,6.6L16,13.2h4.4C19.3,15.2,17,17.9,12.5,20.5Z"></path>
        </g>
      </g>
    </IconBase>);
};

Vitals.defaultProps = {
  title: 'Vitals',
};

export default Vitals;
